<template>
  <div class="classification-container">
    <Search></Search>
    <TabBar :hideSecondMenu="true"></TabBar>
    <MedicationGuidance></MedicationGuidance>
    <IndexCategory bgColor="#fff">
      <li>{{ title }}</li>
    </IndexCategory>
    <div class="content">
      <div class="content-left">
        <div class="content-left--item" v-for="item of artList" :key="item.id">
          <div class="tit">
            <span>[{{ title }}]</span
            ><span @click="goDetailArticle(item.id)">{{ item.title }}</span>
          </div>
          <div class="des">
            {{ item.synopsis.slice(0, 80) }}...
            <span @click="goDetailArticle(item.id)">[阅读全文]</span>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="hot-item">
          <div class="title">热门推荐</div>
          <div class="item-info">
            <ul>
              <li
                v-for="item of hotList.slice(0, 4)"
                :key="item.id"
                @click="goDetailArticle(item.id)"
              >
                {{ item.title.slice(0, 18) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import TabBar from "@/components/pc/nav/TabBar";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import MedicationGuidance from "@/components/pc/information/MedicationGuidance";
import { getArticleList, getArticleHotList } from "@api/public";
export default {
  // 科室分类
  name: "DepartmentClassification",
  components: {
    Search,
    TabBar,
    IndexCategory,
    MedicationGuidance
  },
  data() {
    return {
      title: "",
      categoryId: "",
      param: {
        page: 1,
        limit: 10
      },
      artList: [],
      hotList: []
    };
  },
  watch: {
    $route() {
      this.categoryId = this.$route.query.id;
      this.title = this.$route.query["title"];
      this.getInfoArticleList();
    }
  },
  created() {
    this.categoryId = this.$route.query.id;
    this.title = this.$route.query["title"];
    this.getInfoArticleList();
    getArticleHotList().then(res => {
      this.hotList = res.data;
    });
  },
  methods: {
    getInfoArticleList() {
      getArticleList(this.param, this.categoryId).then(res => {
        this.artList = res.data;
      });
    },
    goDetailArticle(id) {
      this.$router.push({
        path: "articleDetail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.classification-container
  background #fff
  padding-bottom 20px
  .content
    width 1200px
    margin 10px auto 0
    display flex
    justify-content space-between
    &-left
      width 880px
      border 1px solid #dddddd
      padding 0 15px
      &--item
        padding 15px 0 10px
        border-bottom 1px dotted #dddddd
        &:last-child
          border-bottom 0
        .tit
          font-size 14px
          line-height 30px
          color #888
          cursor pointer
          &:hover
            color #0778D0
          span
            &:first-child
              color #0778D0
              margin-right 4px
        .des
          font-size 12px
          color #555555
          font-family serif
          line-height 20px
          span
            color #0778D0
            cursor pointer
    &-right
      width 300px
      .hot-item
        border 1px solid #eeeeee
        .title
          height 35px
          line-height 35px
          background #f7f7f7
          font-size 14px
          font-weight bold
          padding-left 10px
          font-family '宋体'
        .item-info
          margin 10px auto
          font-family: 'Microsoft yahei';
          ul
            padding 0 10px
           li
            height 28px
            line-height 28px
            padding-left 8px
            font-size 14px
            color #555
            display flex
            justify-content space-between
            position relative
            cursor pointer
            &:before
              content ''
              display inline-block
              position absolute
              width 3px
              height 3px
              background #333
              border-radius 50%
              top 12px
              left 2px
</style>
